


























































































import Component, { mixins } from 'vue-class-component';
import get from 'lodash/get';

// import AppProductItem from '../ProductItem/ProductItem.vue';
import ProductListMixin from 'shared/components/Product/productList.mixin';
import AppProductItem from 'shared/components/Product/Item/ProductItem';
import checkCadastralRegions from 'shared/utils/cadastralNumber/checkCadastralRegions';
import loadExternalScript from 'shared/utils/loadExternalScript';
import { environment } from 'shared/environment';

import { AppState } from '../../util/app-state';
import { state } from '../../util/state';

// eslint-disable-next-line no-var
declare var cp: any;

@Component({
  name: 'AppOrderStep',
  components: { AppProductItem },
})
export default class Purchase extends mixins(ProductListMixin) {
  // @Inject() state: AppState;

  // data
  tooltipContent: string = 'Выписка формируется в течение дня, но иногда нужно подождать до трёх дней.';
  loading: boolean = false;
  showCouponExpiredMessage: boolean = false;
  captchaResponse: string = null;
  showCaptchaError: boolean = false;
  allowedFastOrder: boolean = false;
  model: SimpleObject = {
    selected: [],
  };

  // computed
  get state(): AppState {
    return state;
  }

  get products(): OfficialProductMap {
    return this.mapOfficialProducts(state.products.list);
  }

  get totalAmount(): number {
    let amount = 0;

    for (const productId of this.model.selected) {
      const product = state.products.byId[productId];
      let productPrice = parseInt(product.product_price, 10);

      if (product.coupons) {
        const [ coupon ] = product.coupons;
        productPrice -= parseInt(coupon.discount, 10);
      }

      amount += productPrice;
    }

    return amount;
  }

  // lifecycle
  async created() {
    this.model.selected.push(this.products.rightList.default.product_id);
    this.model.selected.push(this.products.egrn.default.product_id);

    if (state.objectInfo.Number) {
      // Если регион доступен для заказа через spv.kadastr.ru, то добавляем продукт для быстрого заказа
      if (checkCadastralRegions(state.objectInfo.Number)) {
        this.allowedFastOrder = true;
      }

      try {
        state.objectInfo = await this.$api.object.InfoFull(state.objectInfo.Number);
      } catch (error) {
        console.error(error);
      }
    }
  }

  async mounted() {
    (window as any).onCaptchaReady = () => this.renderCaptcha();
    const isFirstloading = await loadExternalScript('https://www.google.com/recaptcha/api.js?onload=onCaptchaReady');

    if (!isFirstloading) {
      this.renderCaptcha();
    }
  }

  // methods
  selectProducts(selectedProducts: UUID[]) {
    this.model.selected = selectedProducts;
  }

  async regorder() {
    if (!this.captchaResponse) {
      this.showCaptchaError = true;
      return;
    }

    this.showCaptchaError = false;

    const body: RegorderRequestPayload = {
      order_items: [],
      email: state.form.email,
      recaptcha_response: this.captchaResponse,
    };

    const objectKey = state.objectInfo.Number || state.objectInfo.Address || state.form.query;

    for (const productId of this.model.selected) {
      const orderItem: OrderItem = {
        product_id: productId,
        object_key: objectKey,
        object_address: state.objectInfo.Address,
      };

      if (productId === state.products.byName.EgrnRightList.product_id) {
        orderItem.code = 'skidka100pravo';
      }

      body.order_items.push(orderItem);
    }

    if (state.form.target === 1) {
      body.person_role = state.form.person_role;
      body.phone = state.form.phone;
      body.comment = state.targets[state.form.target];
    }

    this.loading = true;

    try {
      const data = await this.$api.order.RegOrder<RegOrderResponse>(body);
      const { order, person } = data;

      state.orderItems = order.order_items;
      this.$analytics.ym('setUserID', person.id);

      const totalAmount = parseInt(order.total_amount, 10);
      let couponExpired = false;
      let showPaymentDialog = true;

      for (const orderItem of order.order_items) {
        if (orderItem.product_name === 'EgrnRightList') {
          const price = parseInt(orderItem.price, 10);
          if (price > 0) {
            this.products.rightList.default.coupons = null;
            couponExpired = true;
          }
        }
      }

      if (!this.showCouponExpiredMessage && couponExpired) {
        showPaymentDialog = false;
      }

      if (totalAmount > 0 && showPaymentDialog) {
        this.openPaymentDialog(order, person);
      } else {
        this.showCouponExpiredMessage = couponExpired;

        if (!couponExpired) {
          this.$emit('payment-success');
          state.step = 'complete';
        }
      }
    } catch (error) {
      console.error(error);
      const data = error.response ? error.response.data : {};
      const message = data.error;

      if (message === 'missing-input-response') {
        this.showCaptchaError = true;
      }
    }

    this.loading = false;
  }

  async openPaymentDialog(order: OrderResponse, user: User) {
    await loadExternalScript('https://widget.cloudpayments.ru/bundles/cloudpayments');

    const widget = new cp.CloudPayments();

    widget.charge({
      // options
      publicId: environment.cloudpaymentsApiKey, // id из личного кабинета
      description: 'Выписки из ЕГРН', // назначение
      amount: parseInt(order.total_amount as any, 10), // сумма
      currency: 'RUB', // валюта
      invoiceId: order.id, // номер заказа  (необязательно)
      accountId: user.email, // идентификатор плательщика (необязательно)
      skin: 'classic', // дизайн виджета
      data: {
        userId: user.id,
      },
    },
    () => {
      console.log('payment success');
      state.step = 'complete';
      this.$analytics.send('payment_success');

      this.$api.measurement.Conversion({
        totalAmount: order.total_amount,
        transactionId: get(order, 'payment_data.id', order.id),
        items: order.order_items,
      });
    },
    function() {
      console.log('payment error');
      widget.hideWindow();
      // emitter.emit('payment.error');
    });
  }

  renderCaptcha() {
    (window as any).grecaptcha.render(
      'captcha-container',
      {
        sitekey: '6Ldv4MIUAAAAALymeO7iVlGTVSv65mtqqSw7fAIE',
        callback: (token: string) => {
          this.captchaResponse = token;
        },
      }
    );
  }
}
